import { ActionTypes } from '../../constants/action-types';
import { ItineraryReceiveAction } from '../itinerary/types';
import { SegmentTypes } from './../../../models/itinerary';
import { SegmentOptionsReducerActions } from './types';

import { OptionDetailsTypes } from '../../../models/itinerary';

interface Options {
  [optionId: string]: OptionDetailsTypes;
}

interface SegmentOption {
  type: SegmentTypes;
  options: Options;
  optionIds: string[];
}

export interface SegmentOptionsReducerState {
  [segmentId: string]: SegmentOption;
}

export const segmentOptionsInitialState: SegmentOptionsReducerState = {};

export function SegmentOptionsReducer(
  state = segmentOptionsInitialState,
  action: SegmentOptionsReducerActions,
): SegmentOptionsReducerState {
  switch (action.type) {
    // Map the incoming itinerary data to setup default options
    case ActionTypes.ITINERARY_GET_RECEIVE:
      const itinerary = (action as ItineraryReceiveAction).data.itinerary;
      return itinerary.reduce((previousValue, segment) => {
        let options: Options;
        let optionIds: string[];

        switch (segment.segmentType) {
          case 'Air':
            const airSegment = segment.airSegment!;
            const airFares = [
              airSegment.recommended,
              ...(airSegment.shortlists || []),
            ];
            // Get the option ids and options
            optionIds = airFares.reduce((previous: string[], airFare) => {
              return [...previous, airFare.flightId.toString()];
            }, []);
            options = airFares.reduce((previous, airFare) => {
              return { ...previous, [airFare.flightId.toString()]: airFare };
            }, {});
            break;
          case 'Car':
            const carSegment = segment.carSegment!;
            const carOptions = [
              carSegment.recommended,
              ...(carSegment.shortlists || []),
            ];
            // Get the option ids and options
            optionIds = carOptions.reduce((previous: string[], carOption) => {
              return [...previous, carOption.supplierCode];
            }, []);
            options = carOptions.reduce((previous, carOption) => {
              return { ...previous, [carOption.supplierCode]: carOption };
            }, {});
            break;
          case 'Hotel':
            const hotelSegment = segment.hotelSegment!;
            const hotelOptions = [
              hotelSegment.recommended,
              ...(hotelSegment.shortlists || []),
            ];
            // Get the option ids and options
            optionIds = hotelOptions.reduce(
              (previous: string[], hotelOption) => {
                return [...previous, hotelOption.hotelId.toString()];
              },
              [],
            );
            options = hotelOptions.reduce((previous, hotelOption) => {
              return {
                ...previous,
                [hotelOption.hotelId.toString()]: hotelOption,
              };
            }, {});
            break;
        }

        return {
          ...previousValue,
          [segment.orderId]: {
            options: options!,
            optionIds: optionIds!,
            type: segment.segmentType,
          },
        };
      }, {});
    default:
      return state;
  }
}
